<template>
    <home-mobile v-if="isMobile || windowWidth < 1200" />
    <home-desktop v-else />
</template>

<script>
import HomeMobile from '@/views/HomeMobile'
import HomeDesktop from '@/views/HomeDesktop'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'Home',
    components: {
        HomeMobile,
        HomeDesktop
    },
    data() {
        return {
            isMobile
        }
    }
}
</script>
